import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { TURN_STYLES } from '@/styles/theme';

export const Modal = styled('div')<{ isOpen: boolean }>(({ isOpen }) => ({
  position: 'fixed',
  inset: 0,

  display: isOpen ? 'grid' : 'none',
  placeItems: 'center',

  width: '100vw',
  height: '100vh',
  padding: '14px',

  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  boxSizing: 'border-box',

  transition: 'all 300ms ease-in-out',

  opacity: isOpen ? 1 : 0,
  zIndex: isOpen ? 1500 : -50,
  pointerEvents: isOpen ? 'auto' : 'none',
}));

export const ContentWrapper = styled('div')(({ theme }) => ({
  position: 'relative',

  width: '100%',
  height: '100%',
  padding: '24px',

  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSurfaceColor : 'white',
  borderRadius: '4px',

  boxSizing: 'border-box',
}));

export const CloseButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',

  width: '100%',

  fontSize: '20px',

  '& svg': {
    '&:hover': {
      color: TURN_STYLES.primaryAccentColor,
    },
  },
});

export const CloseIconStyled = styled(CloseIcon)({
  cursor: 'pointer',
  transition: 'all 300ms ease-in-out',
});

export const HeadingContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',

  width: '100%',
  margin: '10px 0 30px',

  '& h2': {
    textDecorationLine: 'underline',
  },

  '& h2, & h4': {
    margin: '0',
  },
});

export const CopyToClipboardStyled = styled(CopyToClipboard)({
  cursor: 'pointer',
});

export const DynamicText = styled('span')({
  fontWeight: '400',
});
